(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

// legacy browser alert
function isLegacyIE() {
  var ua = navigator.userAgent;

  if (ua.indexOf("MSIE 6.0") != -1) {
    alert("お使いのウェブブラウザでは当サイトを正常に閲覧できません。ブラウザのバージョンを最新にして再度アクセスしてください。");
  } else if (ua.indexOf("MSIE 7.0") != -1) {
    alert("お使いのウェブブラウザでは当サイトを正常に閲覧できません。ブラウザのバージョンを最新にして再度アクセスしてください。");
  } else if (ua.indexOf("MSIE 8.0") != -1) {
    alert("お使いのウェブブラウザでは当サイトを正常に閲覧できません。ブラウザのバージョンを最新にして再度アクセスしてください。");
  } else if (ua.indexOf("MSIE 9.0") != -1) {
    alert("お使いのウェブブラウザでは当サイトを正常に閲覧できません。ブラウザのバージョンを最新にして再度アクセスしてください。");
  } else if (ua.indexOf("MSIE 10.0") != -1) {
    alert("お使いのウェブブラウザでは当サイトを正常に閲覧できません。ブラウザのバージョンを最新にして再度アクセスしてください。");
  } else {
    return false;
  }
}

isLegacyIE(); //TOP MV Swiper

setTimeout(function () {
  var MvSlider = new Swiper('.top-slider', {
    loop: true,
    effect: 'fade',
    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },
    speed: 2000,
    on: {
      autoplayStart: function autoplayStart() {
        setTimeout(function () {
          var sampleElement = document.getElementById('o-mainvisual-catch');
          sampleElement.classList.add('mv-text-effect');
        }, 500);
      }
    }
  });
}, 1000); //TOP GEMS STORY Swiper

setTimeout(function () {
  var GemsStorySlider = new Swiper('.gemsstory-slider', {
    breakpoints: {
      // 768px以上の場合
      768: {
        loop: true,
        spaceBetween: 20,
        slidesPerView: 3,
        pagination: {
          el: '.gemsstory-pagination',
          type: 'bullets',
          clickable: true
        }
      }
    },
    slidesPerView: 1.5,
    spaceBetween: 20,
    loop: true,
    pagination: {
      el: '.gemsstory-pagination',
      type: 'bullets',
      clickable: true
    }
  });
}, 700); //TOP バナーエリア Swiper

setTimeout(function () {
  var BnrAreaSlider = new Swiper('.bnrarea-slider', {
    breakpoints: {
      // 768px以上の場合
      768: {
        loop: true,
        spaceBetween: 20,
        slidesPerView: 2,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        pagination: {
          el: '.bnrarea-pagination',
          type: 'bullets',
          clickable: true
        }
      }
    },
    loop: true,
    spaceBetween: 20,
    slidesPerView: 1,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    pagination: {
      el: '.bnrarea-pagination',
      type: 'bullets',
      clickable: true
    }
  });
}, 700);
setTimeout(function () {
  var SmartphoneSlider = new Swiper('.smartphone-sp-Slider', {
    loop: true,
    slidesPerView: 1,
    effect: 'fade',
    speed: 1000,
    allowTouchMove: false,
    autoplay: {
      delay: 1000,
      disableOnInteraction: false
    }
  });
  var SmartphoneSceneSlider = new Swiper('.smartphone-scene-Slider', {
    loop: true,
    slidesPerView: 1,
    effect: 'fade',
    speed: 1000,
    allowTouchMove: false,
    autoplay: {
      delay: 1000,
      disableOnInteraction: false
    },
    thumbs: {
      swiper: SmartphoneSlider
    }
  });
}, 1000); //GEMS STORY story01 Swiper

setTimeout(function () {
  var Story01Slider = new Swiper('.story01-slider', {
    loop: true,
    effect: 'fade',
    autoplay: {
      delay: 2000,
      disableOnInteraction: false
    },
    speed: 1000,
    on: {
      autoplayStart: function autoplayStart() {
        setTimeout(function () {
          var sampleElement = document.getElementById('o-mainvisual-catch');
          sampleElement.classList.add('mv-text-effect');
        }, 500);
      }
    }
  });
}, 700); //GEMS STORY otherstory Swiper

setTimeout(function () {
  var OtherStorySlider = new Swiper('.otherstory-slider', {
    breakpoints: {
      // 768px以上の場合
      768: {
        loop: true,
        spaceBetween: 20,
        slidesPerView: 2,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        pagination: {
          el: '.otherstory-pagination',
          type: 'bullets',
          clickable: true
        }
      }
    },
    loop: true,
    spaceBetween: 20,
    slidesPerView: 1,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    pagination: {
      el: '.otherstory-pagination',
      type: 'bullets',
      clickable: true
    }
  });
}, 700); //CAMERA cameraplanning Swiper

setTimeout(function () {
  var CameraPlanningSlider = new Swiper('.cameraplanning-slider', {
    breakpoints: {
      // 768px以上の場合
      768: {
        loop: true,
        spaceBetween: 20,
        slidesPerView: 1,
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        pagination: {
          el: '.cameraplanning-pagination',
          type: 'bullets',
          clickable: true
        }
      }
    },
    loop: true,
    spaceBetween: 20,
    slidesPerView: 1,
    observer: true,
    observeParents: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    pagination: {
      el: '.cameraplanning-pagination',
      type: 'bullets',
      clickable: true
    }
  });
}, 700); //Camtalk Swiper

setTimeout(function () {
  var BnrAreaSlider = new Swiper('.camtalk-slider', {
    breakpoints: {
      // 768px以上の場合
      768: {
        loop: true,
        spaceBetween: 20,
        slidesPerView: 1,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        pagination: {
          el: '.camtalk-pagination',
          type: 'bullets',
          clickable: true
        }
      }
    },
    loop: true,
    spaceBetween: 20,
    slidesPerView: 1,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    pagination: {
      el: '.camtalk-pagination',
      type: 'bullets',
      clickable: true
    }
  });
}, 700); //モーダルウィンドウ

$(function () {
  $('.js-modal-open').each(function () {
    $(this).on('click', function () {
      var target = $(this).data('target');
      var modal = document.getElementById(target);
      $(modal).fadeIn();
      return false;
    });
  });
  $('.js-modal-close').on('click', function () {
    $('.js-modal').fadeOut();
    return false;
  });
});
$(function () {
  $(".accordionbox dt").on("click", function () {
    $(this).next().slideToggle(); // activeが存在する場合

    if ($(this).children(".accordion_icon").hasClass("active")) {
      // activeを削除
      $(this).children(".accordion_icon").removeClass("active");
    } else {
      // activeを追加
      $(this).children(".accordion_icon").addClass("active");
    }
  });
});
$(function () {
  $(".accordionbox02 dt").on("click", function () {
    $(this).next().slideToggle(); // activeが存在する場合

    if ($(this).children(".accordion_icon").hasClass("active")) {
      // activeを削除
      $(this).children(".accordion_icon").removeClass("active");
    } else {
      // activeを追加
      $(this).children(".accordion_icon").addClass("active");
    }
  });
}); //スクロールアニメーション

$(function () {
  load_effect();
  $(window).scroll(function () {
    scroll_effect();
  });
}); //ふわっとロード

function load_effect() {
  var tt = $(window).scrollTop();
  var hh = $(window).height();
  $('.load-fade').each(function () {
    var yy = $(this).offset().top;

    if (tt > yy - hh) {
      $(this).addClass('done');
    }
  });
  $('.load-up').each(function () {
    var yy = $(this).offset().top;

    if (tt > yy - hh) {
      $(this).addClass('done');
    }
  });
} //ふわっとスクロール


function scroll_effect() {
  var tt = $(window).scrollTop();
  var hh = $(window).height();
  $('.scroll-fade').each(function () {
    var yy = $(this).offset().top + 400; //効果発生開始タイミングを操作したい場合は数値を変更する

    if (tt > yy - hh) {
      $(this).addClass('done');
    }
  });
  $('.scroll-up').each(function () {
    var yy = $(this).offset().top + 400; //効果発生開始タイミングを操作したい場合は数値を変更する

    if (tt > yy - hh) {
      $(this).addClass('done');
    }
  });
} //ページ内リンクスムーススクロール


$(function () {
  var headerHight = 100; //ヘッダの高さ
  // #で始まるアンカーをクリックした場合に処理

  $('a[href^="#"]').click(function () {
    // スクロールの速度
    var speed = 800; // ミリ秒
    // アンカーの値取得

    var href = $(this).attr("href"); // 移動先を取得

    var target = $(href == "#" || href == "" ? "html" : href); // 移動先を数値で取得

    var position = target.offset().top - headerHight; //ヘッダの高さ分位置をずらす
    // スムーススクロール

    $("body,html").animate({
      scrollTop: position
    }, speed, "swing");
    return false;
  });
});

},{}]},{},[1]);
